var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-container',{staticStyle:{"width":"1200px","margin-top":"10px"},attrs:{"fluid":""}},[_c('app-overlay',{attrs:{"loading":_vm.loading}}),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('app-chart',{attrs:{"data":_vm.timeSeries,"total":_vm.total,"time-unit":_vm.timeUnit}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }